<ng-container *ngComponentOutlet="data"></ng-container>
